import React, { useState } from "react";
import { ContactUsApi } from "../services/Api";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    organization: "",
    position: "",
    message: "",
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    // Map phone to phoneNumber for API compatibility
    const apiData = {
      ...formData,
      phoneNumber: formData.phone,
    };

    try {
      await ContactUsApi(apiData);
      setStatus("✅ Message sent successfully!");
      setFormData({
        name: "",
        phone: "",
        email: "",
        organization: "",
        position: "",
        message: "",
      });
    } catch (error) {
      setStatus("❌ Failed to send. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title">Let's Connect</h1>
      <p className="contact-subtitle">
        Share your details and we’ll get in touch with you.
      </p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your full name"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="123-456-7890"
            required
            maxLength={10}
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@email.com"
            required
          />
        </div>

        <div className="form-group">
          <label>Organization</label>
          <input
            type="text"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
            placeholder="Company / Organization"
            required
          />
        </div>

        <div className="form-group">
          <label>Position</label>
          <input
            type="text"
            name="position"
            value={formData.position}
            onChange={handleChange}
            placeholder="Your position or role"
            required
          />
        </div>

        <div className="form-group">
          <label>How can we help you?</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Tell us what you need help with..."
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Submit"}
        </button>
        {status && <p className="form-status">{status}</p>}
      </form>

      <div className="additional-contact-info">
        <p>📧 Email us: <a href="mailto:info@emomatrix.com">info@emomatrix.com</a></p>
        <p>📞 Call us: <strong>3265968547</strong></p>
      </div>
    </div>
  );
};

export default ContactUs;
